import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import Rocket from "../images/rocket.svg";

const styles = {
  "@media (min-width: 1300px)": {
    container: {
      height: "75vh",
      width: "100%",
    },
    first: {
      height: "100%",
    },
    rocket: {
      height: "100%",
      width: "100%",
      background: "transparent url(" + Rocket + ")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "-165% 150px",
      backgroundSize: "120%",
      backgroundOrigin: "border-box",
    },
    cadetText: {
      maxWidth: "90%",
      left: "15%",
      top: "25%",
      position: "absolute",
      wordWrap: "break-word !important",
      whiteSpace: "initial!important",
      width: "506px",
      height: "216px",
      lineHeight: "68px",
      textAlign: "left",
      fontFamily: "Avenir",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "60px",
      color: "#2a6196",
    },
    cadetSubtitle: {
      paddingTop: "5%",
      position: "absolute",
      overflow: "visible",
      width: "90%",
      height: "90px",
      lineHeight: "30px",
      textAlign: "left",
      fontSize: "20px",
      color: "#2a6196",
    },
  },
  "@media (max-width: 1300px)": {
    container: {
      height: "75vh",
      width: "100%",
    },
    cadetText: {
      maxWidth: "90%",
      left: "25%",
      top: "25%",
      position: "absolute",
      wordWrap: "break-word !important",
      whiteSpace: "initial!important",
      width: "506px",
      height: "216px",
      lineHeight: "68px",
      textAlign: "left",
      fontFamily: "Avenir",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "60px",
      color: "#2a6196",
    },
    cadetSubtitle: {
      paddingTop: "5%",
      position: "absolute",
      overflow: "visible",
      width: "90%",
      height: "90px",
      lineHeight: "30px",
      textAlign: "left",
      fontSize: "20px",
      color: "#2a6196",
    },
  },
  "@media (max-width: 600px)": {
    cadetText: {
      maxWidth: "90% !important",
      left: "0% !important",
      paddingLeft: "7%",
      paddingRight: "7%",
      wordWrap: "break-word !important",
      whiteSpace: "initial!important",
      width: "auto !important",
      height: "auto !important",
      lineHeight: "50px !important",
      fontSize: "2.5em !important",
    },
    cadetSubtitle: {
      paddingTop: "10% !important",
      lineHeight: "30px !important",
      fontSize: "0.5em !important",
    },
  },
};

class landing extends Component {
  render() {
    const { classes } = this.props;
    // TEMPORARY: add visible indicator that the user is logged in

    return (
      <div className={classes.container}>
        <div className={classes.first}>
          <div className={classes.rocket}>
            <div className={classes.cadetText}>
              <span>Hi, Cadet!</span>
              <br />
              <span>Gusto mo ba maging </span>
              <span
                style={{
                  color: "rgba(255,207,45,1)",
                }}
              >
                teacher
              </span>
              <span>?</span>
              <div className={classes.cadetSubtitle}>
                <span>
                  CareerX’s bite-sized, personalized career exploration programs
                  help you discover whether teaching is right for you.
                </span>
                <br />
                <br />
                <Button
                  variant="contained"
                  color="secondary"
                  component={Link}
                  to="/signup"
                >
                  SIGN UP NOW
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(landing);
